import PropTypes from "prop-types";

export const baseSettingShape = PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.object
});